import React from 'react';
import * as XLSX from 'xlsx';
import '../css/List.css';

const DownloadButton = ({ data, fileName }) => {
  const handleDownload = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName || "Download"}.xlsx`);
  };

  return (
    <button onClick={handleDownload} className="btn btn-primary download-button">
      Download as Excel
    </button>
  );
};

export default DownloadButton;
